import template from './pos.html';

const posComponent = {
  restrict: 'E',
  bindings: {},
  template
};

export default posComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/dashboard/pos/pos.component.js
 **/